require('./popovers/collection_builder_on_search.js.coffee');

Popovers = LP.module 'Popovers'

Popovers.init = ->
  timeoutId = null

  # Tooltips that don't disappear when you move into them.  Good if they have links in them.
  # @see http://stackoverflow.com/questions/7703878/how-can-i-hold-twitter-bootstrap-popover-open-until-my-mouse-moves-into-it
  $('[rel=hover-popover]')
  .popover({ trigger: 'manual', sanitize: false })
  .on('mouseenter', ->
    clearTimeout timeoutId
    $tip = $(@).data('bs.popover').tip()
    if !$tip.is(':visible')
      $(@).popover('show')
      $tip.on 'mouseleave', =>
        timeoutId = setTimeout(=>
          $(@).popover('hide')
        , 100)
  )
  .on('mouseleave', (e) ->
    setTimeout(=>
      $(@).popover('hide') if !$('.popover:hover').length
    , 100)
  )

  # 'focus-popover' to close on outside click without interfering with Draggable event
  $('body').on 'click', (e) ->
    $('[rel="focus-popover"]').each ->
      if !$(this).is(e.target)
        $(this).popover('hide')

  $('[rel=popover]').popover(sanitize: false).click (e) => e.preventDefault()
  $('body').off 'click.popover.dismiss'
  $('body').on 'click.popover.dismiss', '.popover [data-dismiss=popover]', (e) ->
    $el = $(this)
    $($el.data('target')).trigger 'click'
    false

Popovers._howToTemplate = (extraClasses) ->
  '<div class="popover how-to-popover ' + extraClasses + '" role="tooltip">
    <div class="arrow"></div>
    <h3 class="popover-title"></h3>
    <div class="popover-content"></div>
  </div>'

# Hides the HowTo popovers under the header when scrolling occurs.
Popovers.updateHowToPopoversVisibility = (popovers) ->
  header       = $('#header-wrap')
  headerOffset = $(window).scrollTop()
  headerOffset += header.height() unless header.hasClass('headroom--unpinned')
  popovers.map (arr, i) ->
    zIndex = if headerOffset > arr[0] then 0 else $('#header-wrap').css('zIndex') * 1 + 1
    arr[1].css('zIndex', zIndex)

# Popover bs issue
# @see https://github.com/twbs/bootstrap/issues/16732#issuecomment-165229037
$('body').on "hidden.bs.popover", (e) ->
  if e.target.tagName == "I"
    $(e.target).blur();
    $(e.target).data("bs.popover").inState.click = false;
